//Dependencies
import React, { useEffect, useCallback, useState } from 'react';
import { Map, TileLayer } from "react-leaflet";
import { useDispatch } from 'react-redux';

const Map01 = (props) =>
{
  const dispatch = useDispatch();

  const {  layers, center, height, list01, list02, paddingBottom, paddingTop, zoom } = props;  
 
  const layer1 = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
  const layer2 = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

  const [markerList, setMarkerList] = useState();

  /* MARKERS */
  useEffect(() => 
  {
    if(zoom >= 12)
      {
        setMarkerList(list02);
      }
      else
      {
        setMarkerList(list01);
      }
  }, [list01, list02, zoom]);  

  const dragMap = useCallback((e) => 
  {
    dispatch({type: 'SET_CENTER', center : e.target.getCenter()});
  }, [dispatch]); 

  const mapZoom = (e) =>
  {
    dispatch({type: 'SET_ZOOM', zoom : e.target.getZoom()});
  }
  
  return(
    <div
      style = {{height : height, width : '100%', paddingTop : paddingTop, paddingBottom : paddingBottom }}
    >
      <Map
        center = {center} 
        zoom = {zoom} 
        style = {{height : '100%', width : '100%'}}
        onzoomend = {(e) => mapZoom(e)} 
        ondragend = {(e) => dragMap(e)}
      >
        <TileLayer
          url = {layers ? layer2 : layer1}
          minZoom = {5}
          maxZoom = {19}
        />

        {markerList}
      </Map>
    </div>
  );
}

export default Map01;